export const SOCIAL_SHARING = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  EMAIL: 'email',
  COPY_URL: 'copy',
};

export const ROOSTERMONEY_TWITTER_HANDLE = 'rooster_money';
